export const DESKTOP_MODAL_WIDTH = 540;
